"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeApprovedFeedstockToastReducer = exports.deleteApprovedFeedstockErrorReducer = exports.deleteApprovedFeedstockSuccessReducer = exports.deleteApprovedFeedstockReducer = exports.editApprovedFeedstockErrorReducer = exports.editApprovedFeedstockSuccessReducer = exports.editApprovedFeedstockReducer = exports.createApprovedFeedstockErrorReducer = exports.createApprovedFeedstockSuccessReducer = exports.createApprovedFeedstockReducer = exports.getApprovedFeedstocksErrorReducer = exports.getApprovedFeedstocksSuccessReducer = exports.getApprovedFeedstocksReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const toastInitialState = {
    isOpen: false,
    message: "",
    status: undefined,
};
const initialState = {
    approvedFeedstocks: [],
    areApprovedFeedstocksLoading: false,
    hasErrorLoadingApprovedFeedstocks: false,
    isCreatingAprovedFeedstock: false,
    isEditingAprovedFeedstock: false,
    isDeletingApprovedFeedstock: false,
    approvedFeedstocksToastStatus: toastInitialState,
    // filteredPorts: [],
    // isSavePromptVisible: false,
    // isCreatingPort: false,
    // createPortError: false,
    // createPortSuccess: false,
};
const approvedFeedstockSlice = (0, toolkit_1.createSlice)({
    name: "approvedFeedstocks",
    initialState,
    reducers: {
        getApprovedFeedstocksReducer: (state) => {
            state.areApprovedFeedstocksLoading = true;
        },
        getApprovedFeedstocksSuccessReducer: (state, action) => {
            state.approvedFeedstocks = action.payload;
            state.areApprovedFeedstocksLoading = false;
        },
        getApprovedFeedstocksErrorReducer: (state) => {
            state.areApprovedFeedstocksLoading = false;
            state.hasErrorLoadingApprovedFeedstocks = true;
        },
        createApprovedFeedstockReducer: (state) => {
            state.isCreatingAprovedFeedstock = true;
        },
        createApprovedFeedstockSuccessReducer: (state) => {
            state.isCreatingAprovedFeedstock = false;
            state.approvedFeedstocksToastStatus.isOpen = true;
            state.approvedFeedstocksToastStatus.message = "Approved feedstock created successfully";
            state.approvedFeedstocksToastStatus.status = "success";
        },
        createApprovedFeedstockErrorReducer: (state) => {
            state.isCreatingAprovedFeedstock = true;
        },
        editApprovedFeedstockReducer: (state) => {
            state.isEditingAprovedFeedstock = true;
        },
        editApprovedFeedstockSuccessReducer: (state) => {
            state.isEditingAprovedFeedstock = false;
            state.approvedFeedstocksToastStatus.isOpen = true;
            state.approvedFeedstocksToastStatus.message = "Approved feedstock edited successfully";
            state.approvedFeedstocksToastStatus.status = "success";
        },
        editApprovedFeedstockErrorReducer: (state) => {
            state.isEditingAprovedFeedstock = true;
        },
        deleteApprovedFeedstockReducer: (state) => {
            state.isDeletingApprovedFeedstock = true;
        },
        deleteApprovedFeedstockSuccessReducer: (state) => {
            state.isDeletingApprovedFeedstock = false;
            state.approvedFeedstocksToastStatus.isOpen = true;
            state.approvedFeedstocksToastStatus.message = "Approved feedstock deleted successfully";
            state.approvedFeedstocksToastStatus.status = "success";
        },
        //TODO: FIX ERROR ACTION
        deleteApprovedFeedstockErrorReducer: (state) => {
            state.isDeletingApprovedFeedstock = false;
        },
        closeApprovedFeedstockToastReducer: (state) => {
            state.approvedFeedstocksToastStatus = toastInitialState;
        },
        // filterPortsByCountry: (
        //   state: ApprovedFeedstocksState,
        //   action: PayloadAction<string>
        // ) => {
        //   const filterPortsByCountry =
        //     state.ports.filter((port) => {
        //       return port.country.id === action.payload;
        //     }) || [];
        //   state.filteredPorts = filterPortsByCountry;
        // },
        // onShowSavePrompt: (state: ApprovedFeedstocksState) => {
        //   state.isSavePromptVisible = true;
        // },
        // onHideSavePrompt: (state: ApprovedFeedstocksState) => {
        //   state.isSavePromptVisible = false;
        // },
        // createPort: (state: ApprovedFeedstocksState) => {
        //   state.isCreatingPort = true;
        // },
        // createPortSuccess: (state: ApprovedFeedstocksState) => {
        //   state.isCreatingPort = false;
        //   state.createPortSuccess = true;
        // },
        // createPortError: (state: ApprovedFeedstocksState) => {
        //   state.isCreatingPort = false;
        //   state.createPortError = true;
        // },
        // openPortsToast: (
        //   state: ApprovedFeedstocksState,
        //   action: PayloadAction<{
        //     status: "success" | "info" | "error" | undefined;
        //     message?: string;
        //   }>
        // ) => {
        //   state.portToastStatus.status = action.payload.status;
        //   state.portToastStatus.message = action.payload.message;
        //   state.portToastStatus.isOpen = true;
        // },
        // closePortsToast: (state: ApprovedFeedstocksState) => {
        //   state.portToastStatus.isOpen = false;
        //   state.portToastStatus.status = undefined;
        //   state.portToastStatus.message = "";
        // },
    },
});
_a = approvedFeedstockSlice.actions, exports.getApprovedFeedstocksReducer = _a.getApprovedFeedstocksReducer, exports.getApprovedFeedstocksSuccessReducer = _a.getApprovedFeedstocksSuccessReducer, exports.getApprovedFeedstocksErrorReducer = _a.getApprovedFeedstocksErrorReducer, exports.createApprovedFeedstockReducer = _a.createApprovedFeedstockReducer, exports.createApprovedFeedstockSuccessReducer = _a.createApprovedFeedstockSuccessReducer, exports.createApprovedFeedstockErrorReducer = _a.createApprovedFeedstockErrorReducer, exports.editApprovedFeedstockReducer = _a.editApprovedFeedstockReducer, exports.editApprovedFeedstockSuccessReducer = _a.editApprovedFeedstockSuccessReducer, exports.editApprovedFeedstockErrorReducer = _a.editApprovedFeedstockErrorReducer, exports.deleteApprovedFeedstockReducer = _a.deleteApprovedFeedstockReducer, exports.deleteApprovedFeedstockSuccessReducer = _a.deleteApprovedFeedstockSuccessReducer, exports.deleteApprovedFeedstockErrorReducer = _a.deleteApprovedFeedstockErrorReducer, 
// getPorts,
// getPortsError,
// getPortsSuccess,
// filterPortsByCountry,
// onShowSavePrompt,
// onHideSavePrompt,
// createPort,
// createPortError,
// createPortSuccess,
// openPortsToast,
exports.closeApprovedFeedstockToastReducer = _a.closeApprovedFeedstockToastReducer;
exports.default = approvedFeedstockSlice.reducer;
